module.exports = __webpack_public_path__ + "img/experience12.d0f1b17f.jpg";